module.exports = __webpack_public_path__ + "static/media/Ask_me_for_Help.a367f4bf.gif";